import { FC, useCallback, useState } from 'react'
import { Client as Styletron } from 'styletron-engine-atomic'
import { Provider as StyletronProvider } from 'styletron-react'
import { PersistGate } from 'redux-persist/integration/react'
import { LightTheme, BaseProvider } from 'baseui'
import { AppProvider } from './contexts/AppContext'
import store, { persistor } from '@store/store'
import { Provider } from 'react-redux'
import { EditorProvider } from './scenes/engine/context/editor'
// Import the pixel-manipulation context directly from its module rather than
// the engine barrel. Going through the barrel previously evaluated
// `./scenes/engine/index.ts`, which used to eagerly pull `BZCanvas` into
// every route — including pure create / dashboard pages that never mount
// the editor canvas. The barrel no longer re-exports `BZCanvas`, but we
// keep this direct import as the canonical pattern: the provider only
// needs the context module's small fabric + handler surface, not the
// full engine entry point.
import { PixelManipulationEditorProvider } from './scenes/engine/context/pixelManipulationEditor'
import useStyletronHotjarSync from './utils/useStyletronHotjarSync'

const engine = new Styletron()

const Providers: FC = ({ children }) => {
  useStyletronHotjarSync()

  const [editorContextKey, setEditorContextKey] = useState(0)

  const resetEditorContext = useCallback(() => {
    setEditorContextKey(prev => prev + 1)
  }, [])

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <StyletronProvider value={engine}>
          <EditorProvider key={editorContextKey}>
            <PixelManipulationEditorProvider>
              <BaseProvider theme={LightTheme}>
                <AppProvider onResetEditorContext={resetEditorContext}>
                  {children}
                </AppProvider>
              </BaseProvider>
            </PixelManipulationEditorProvider>
          </EditorProvider>
        </StyletronProvider>
      </PersistGate>
    </Provider>
  )
}

export default Providers
